import React, { useState, useContext } from 'react';
import i18n from '../i18n';
import appContext from '../AppContext';

function Header(props){
  const {locale} = useContext(appContext);

  const [lang, setLang] = useState('en');

  const headerLinks = [{
    id: 1,
    title: "School Finder",
    icon: "SchoolFinder.png",
    link: "http://find.myschooldc.org/",
    mobile: false
  },{
    id: 2,
    title: "Apply",
    icon: "Apply.png",
    link: "https://apply.myschooldc.dc.gov/login.aspx",
    mobile: true
  },{
    id: 3,
    title: "202-888-6336",
    icon: "Phone.png",
    link: "tel:202-888-6336",
    mobile: true
  },{
    id: 4,
    title: "info.myschooldc@dc.gov",
    icon: "Email.png",
    link: "mailto:info.myschooldc@dc.gov",
    mobile: true
  },{
    id: 5,
    title: "Alert Sign-Up",
    icon: "Alert.png",
    link: "https://www.myschooldc.org/sign-alerts",
    mobile: false
  },{
    id: 6,
    title: "School Staff",
    icon: "SchoolStaff.png",
    link: "https://www.myschooldc.org/schoolstaff",
    mobile: false
  }];

  const languages = [{
    title: "English",
    variable: 'en'
  },{
    title: "Español",
    variable: 'es'
  }];

  const handleLangChange = (newLang) => {
    // if switching languages
    if (lang !== newLang) {
      // set state and change language across app
      setLang(newLang);
      if (locale !== newLang) {
        i18n.changeLanguage(newLang);
      }
    }
  };

  return (
    <div className="bg-[#f6d79c] w-full md:rounded-t-xl md:mt-4 overflow-hidden print:hidden">
      <div className='p-3'>
        <div className='flex flex-row'>
          <div className='md:px-6 my-auto'>
              <img alt='MySchools DC Logo' className='w-[120px] sm:w-[140px] mr-5' src='./MSDC-Logo.png' />
          </div>
          <div className='flex flex-col justify-between items-end flex-grow'>
            <div className='flex flex-row'>
              {
                languages.map((item, i) => {
                  return (<div key={ 'langSwitch_' + item.variable }
                    className={ 'text-my-emerald text-sm px-2 py-1' + (lang === item.variable ? 'border bg-white font-bold rounded-lg' : 'bg-none cursor-pointer ') } 
                    onClick={ () => handleLangChange(item.variable) } >
                    { item.title }
                  </div>)
                })
              }
            </div>
            <div className='flex flex-col md:flex-row flex-wrap justify-end'>
              {
                headerLinks.map((item, i) => {
                  return (
                    <div key={"headerlink" + item.id} className={'flex-row min-w-fit md:border-r-2 border-r-my-emerald px-2 pb-1 md:pt-1 last:border-0' + (item.mobile ? ' flex' : ' hidden md:flex')}>
                      <img className='w-5 h-5' src={"./icons/" + item.icon} alt={ item.title + ' Icon'}/>
                      <div className='pl-3 pb-1 text-my-emerald text-sm font-bold hover:text-[#97afb4] whitespace-nowrap'>
                        <a href={ item.link }>{ item.title }</a>
                      </div>
                    </div>
                  );
                })
              }
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

Header.propTypes = {};

Header.defaultProps = {};

export default Header;
